module.exports = __webpack_public_path__ + "static/media/S2P2_genetic-testing.d326bf7f.mp3";